import './vendor';
import animation from './components/animation';
import form from './components/form';

document.addEventListener('DOMContentLoaded', () => {
	animation.init();
	form.init();
});
